<script>
	export let data;

	import { isMenuClosed } from '../../../stores/variables';
</script>

{#if data}
	{#await data then result}
		<div class="banner {$isMenuClosed ? 'menu-closed' : 'menu-opened'}">
			<span class="banner__title">Служба поддержки TopDent</span>
			<a href={'tel:' + result.supportPhone2} class="banner__phone">{result.supportPhone}</a>
			<span class="banner__email">{result.supportEmail}</span>
			<!-- <span class="banner__ask">Задать вопрос</span> -->
			<a href="https://topdent-promo.ru" target="_blank" class="banner__promo">Продвижение стоматологии</a>
			<a href="https://topdent-promo.ru" target="_blank" class="banner__promo">Создание и обслуживание сайтов на тильде</a>
		</div>
	{/await}
{/if}

<style lang="scss">
	.banner {
		display: flex;
		flex-direction: column;
		font-size: 16px;
		line-height: 24px;
		padding: 32px 24px 16px;
		margin-top: auto;

		@media (min-width: 992px) {
			max-width: 280px;
		}

		&.menu-closed {
			display: none;
		}

		&__title {
			color: var(--text-main-1);
			font-weight: 700;
			font-size: 16px;
			margin-bottom: 10px;
		}
		&__phone,
		&__promo,
		&__email {
			font-size: 14px;
			color: var(--text-gray-1);
			margin-bottom: 6px;
		}
		&__phone,
		&__promo {
			&:hover {
				color: var(--text-main-1);
			}
		}

		// &__ask {
		// 	font-size: 13px;
		// 	color: var(--text-main);
		// 	padding: 5px 12px;
		// 	background: var(--bg-black-active);
		// 	align-self: flex-start;
		// 	border-radius: 8px;
		// 	cursor: pointer;
		// }
	}
</style>
